<template>
  <h2 class="text-lg font-semibold">
    <slot />
  </h2>
</template>
